export default __webpack_public_path__ + "static/media/twitter_line.3142e699.svg";